import * as z from 'zod';

import { BorrowerId, PortalUserId, RepayAccountId } from '../BrandedIds';
import { zodBrandedUuid } from '../utils/Zod';
import { BaseLoanEvent } from './BaseLoanEvent';

const DwollaAutopaySettingsInput = z.object({
  bankUrl: z.string(),
  portalUserId: zodBrandedUuid<PortalUserId>(),
  type: z.literal('dwolla'),
});

const UsioAutopaySettingsInput = z.object({
  confirmationId: z.string(),
  borrowerId: zodBrandedUuid<BorrowerId>(),
  type: z.literal('usio'),
  dayOfTheMonth: z.number().optional(),
});

const RepayAutopaySettingsInput = z.object({
  type: z.literal('repay'),
  accountId: zodBrandedUuid<RepayAccountId>(),
  borrowerId: zodBrandedUuid<BorrowerId>(),
  dayOfTheMonth: z.number(),
});

const AutopaySettingsInput = z.discriminatedUnion('type', [
  DwollaAutopaySettingsInput,
  UsioAutopaySettingsInput,
  RepayAutopaySettingsInput,
]);
export type AutopaySettingsInput = z.infer<typeof AutopaySettingsInput>;

export const UpdateAutopaySettingsEvent = BaseLoanEvent.extend({
  type: z.literal('updateAutopaySettings'),
  autopaySettingsInput: AutopaySettingsInput.optional(),
  isUsio: z.boolean().optional(), // disabled event needs indicator for audit log
});
export type UpdateAutopaySettingsEvent = z.infer<typeof UpdateAutopaySettingsEvent>;
